import { render } from "./ProjectsGrid.vue?vue&type=template&id=7728697e"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Dominik/Documents/GitHub/deptart/deptart/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__